import * as React from "react";
import { useEffect, useState } from "react";
import "./SignIn2.scss";
import background from "../../assets/img/background-new.gif";
import logo from "../../assets/img/logo-new.png";
import { Button, Form, Input, Switch, Checkbox, Radio } from "antd";
import { useHistory } from "react-router-dom";
import { REQUEST_LIST_ROUTE, RESOLUTION, EQUIPMENT_INDICATOR_LIST_ROUTE } from "../../routes/const";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/actions/authActions";
import { useForm } from "antd/es/form/Form";
import useRoles from "../../hooks/useRoles";
import { useNCALayerClient } from "../../functions/sign/SignHooks";
import { env } from "../../env";
import { AndroidFilled } from "@ant-design/icons";
import { Android } from "@mui/icons-material";
import { Link } from "@mui/material";
import { Typography } from 'antd';
import Text from "antd/lib/typography/Text";
const { Title } = Typography;

const SignIn2 = () => {
    const [form] = useForm();
    const history = useHistory();
    const dispatch = useDispatch();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const user = useSelector((state) => state.auth);
    const { loading, success, error } = user;
    const { isCommittee, roles } = useRoles();

    const [client, ready] = useNCALayerClient();
    // not working why?
    //const [isEcpMethod, setIsEcpMethod] = useState(env.ecpMethodEnabled || process.env.NODE_ENV !== 'development');
    const [isEcpMethod, setIsEcpMethod] = useState(true);
    console.log(env.ecpMethodEnabled);
    //const [isEcpMethod, setIsEcpMethod] = useState(true);
    const [ecpLoginXml, setEcpLoginXml] = useState(null);
    const [ecpReady, setEcpReady] = useState(false);
    const [ecpMessage, setEcpMessage] = useState(null);
    const [ecpLoginSignedXml, setEcpLoginSignedXml] = useState(null);
    const [ecpType, setEcpType] = useState('PKCS12'); // 'PKCS12' для ЭЦП, 'AKKaztokenStore' для казтокена

    useEffect(() => {
        if (!client)
            return;

        client.onopen = function () {
            setEcpReady(true);
            setEcpMessage(null);
        }

        client.onclose = function () {
            setEcpReady(false);
            setEcpMessage("Ошибка соединения с провайдером ЭЦП (NCALayer)");
        }

        client.onmessage = function (msg) {
            if (msg?.code === '200' || msg?.code === 200) {
                setEcpLoginSignedXml(msg.responseObject);
                setEcpMessage(null);
            } else {
                setEcpLoginSignedXml(null);
                setEcpMessage(msg?.message || "Ошибка при подписи через NCALayer");
            }
        };

    }, [client]);

    useEffect(() => {
        if (success) {
            setEmail("");
            setPassword("");
            setEcpLoginXml(null);
            setEcpLoginSignedXml(null);
            const indicatorOnlyRoles = ["Metrolog", "SMK"];
            const isIndicatorOnlyUser = roles.length > 0 &&
                roles.every((role) => indicatorOnlyRoles.includes(role));

            history.push(
                isCommittee()
                    ? RESOLUTION
                    : isIndicatorOnlyUser
                        ? EQUIPMENT_INDICATOR_LIST_ROUTE
                        : REQUEST_LIST_ROUTE
            );
        }
    }, [history, success, isCommittee, roles]);

    useEffect(() => {
        if (!email)
            return;

        if (email == 'admin')
            setIsEcpMethod(false);
        else
            setIsEcpMethod(true);
    }, [email]);

    useEffect(() => {
        // При изменении режима ЭЦП сбрасываем тип на PKCS12 по умолчанию
        if (isEcpMethod) {
            setEcpType('PKCS12');
            setEcpLoginXml(null);
            setEcpLoginSignedXml(null);
        }
    }, [isEcpMethod]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        await dispatch(login(email, password, ecpLoginXml, ecpLoginSignedXml));
    };

    const validateAndSubmit = (event) => {
        if (!isEcpMethod) {
            form
                .validateFields()
                .then(() => handleSubmit(event))
                .catch((err) => console.log(err));
        } else {
            handleSubmit(event);
        }
    };
    const willSelectEcp = () => {
        const d = new Date();
        const n = d.getTime();
        const loginXml = '<login><time>' + n + '</time></login>';
        setEcpLoginXml(loginXml);
        setEcpLoginSignedXml(null); // Очищаем предыдущую подпись

        // Используем выбранный тип хранилища: PKCS12 для ЭЦП, PKCS11/AKKaztokenStore для казтокена
        client.signXml(ecpType, 'AUTHENTICATION', loginXml);
    }

    const handleEcpTypeChange = (e) => {
        setEcpType(e.target.value);
        setEcpLoginXml(null);
        setEcpLoginSignedXml(null); // Очищаем подпись при смене типа
        setEcpMessage(null);
    }
    return (
        <div className="layout">
            <div
                style={{
                    width: '90%',      
                    maxWidth: '600px',
                    margin: '30px auto',
                    marginLeft: '50px',
                    marginRight: '70px',
                    padding: '20px',
                //    border: '1px solid #d9d9d9',
               //     borderRadius: '10px',
                    backgroundColor: 'white',
                //    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                //    textAlign: 'center',
                }}
            >
                <div style={{textAlign: 'center'}}>
                <img src={logo} alt="login"
                    style={{ marginBottom: '10px' }}
                />
                <Title level={4} style={{ marginBottom: '5px', color: '#427DB2', fontSize: '16px', marginTop: '10px' }}>
                    НАЦИОНАЛЬНЫЙ ЦЕНТР ЭКСПЕРТИЗЫ
                </Title>
                <Text type="secondary" style={{ display: 'block', marginBottom: '20px', color: '#051B2E', fontSize: '16px', fontWeight: 500 }}>
                    Лабораторно-информационная система
                </Text>
                </div>
                {/* <p className="enter">Вход в систему</p>                    */}
                <Title level={4} style={{ fontWeight: 500, color: '#333', textAlign: 'center', marginBottom: '30px', marginTop: '100px' }}>Вход в систему</Title>
                <Form form={form}>
                    <Form.Item
                        style={{ marginBottom: "12px" }}
                        name="email"
                        rules={[{ required: true, message: <></> }]}
                    >
                        <Input
                            placeholder="Логин"
                            autoFocus
                            width={400}
                            autoComplete="email"
                            required
                            style={{ background: "white", borderRadius: "5px" }}
                            name="email"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        style={{ marginBottom: error ? "16px" : "0px" }}
                        name="password"
                        rules={[{ required: true, message: <></> }]}
                    >
                        <Input
                            placeholder="Пароль"
                            type="password"
                            autoComplete="current-password"
                            id="password"
                            name="password"
                            style={{ background: "white", borderRadius: "5px" }}
                            required
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Form.Item>

                    {error && <p className="access-error">Неправильный логин или пароль {error}</p>}

                    <Form.Item name="remember" valuePropName="checked" style={{ marginBottom: '0px', marginTop: '20px' }}>
                        <Checkbox defaultChecked>Запомнить меня</Checkbox>
                    </Form.Item>

                    <Form.Item name="twoFactor" valuePropName="checked">
                        <Checkbox
                            id="isEcpMethod"
                            name="isEcpMethod"
                            value={isEcpMethod}
                            onChange={(e) => {
                                setIsEcpMethod(e.target.checked);
                            }}
                            disabled
                        >Двухфакторная по ЭЦП</Checkbox>
                    </Form.Item>

                    {isEcpMethod && (
                        <Form.Item
                            style={{ marginBottom: "12px" }}
                            name="ecpType"
                        >
                            <Radio.Group 
                                value={ecpType}
                                defaultValue="PKCS12"
                                onChange={handleEcpTypeChange}
                                style={{ width: '100%' }}
                            >
                                <Radio value="PKCS12">ЭЦП (файловый)</Radio>
                                <Radio value="AKKaztokenStore">Казтокен (физический носитель)</Radio>
                            </Radio.Group>
                        </Form.Item>
                    )}

                    <Form.Item
                        style={{ marginBottom: "12px" }}
                        name="chooseEcp"
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: '10px',
                            }}
                        >
                            {isEcpMethod && <>

                                <Button
                                    block={false}
                                    type="ghost"
                                    style={{
                                        width: '100%',
                                        height: '40px',
                                        color: 'white',
                                        backgroundColor: '#427DB2',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                    }}
                                    onClick={willSelectEcp}
                                    loading={loading}
                                    disabled={!ecpReady}
                                >
                                    {ecpType === 'AKKaztokenStore' ? 'Выбрать казтокен' : 'Выбрать ЭЦП'}
                                </Button>
                                {ecpMessage && <span>{ecpMessage}</span>}

                            </>}
                            <Button
                                type="primary"
                                htmlType="submit"
                                style={{
                                    width: '100%',
                                    backgroundColor: 'white',
                                    height: '40px',
                                    borderRadius: '8px',
                                    borderColor: '#427DB2',
                                    color: '#427DB2',
                                    fontSize: '16px',
                                }}
                                onClick={validateAndSubmit}
                                loading={loading}
                                disabled={process.env.NODE_ENV === 'development' ? false : (isEcpMethod && !ecpLoginSignedXml)}
                            >
                                Войти
                            </Button>
                        </div>
                    </Form.Item>

                    <Form.Item
                        style={{ marginBottom: "12px", marginTop: "12px" }}
                    >
                        <Link
                            style={{ color: '#427DB2' }}
                            href="https://ekpo.nce.kz/s3/api/v1/file/download2?bucketName=app&key=mobile&objectName=16786c6f-b5fe-4293-ad42-07cbf31b9670__app-release.apk">
                            <AndroidFilled style={{ fontSize: 22, marginRight: "5px", color: '#427DB2' }} />
                            Скачать мобильное приложение
                        </Link>
                    </Form.Item>
                </Form >
            </div >
            <img src={background} 
             style={{
                width: '55%', 
                height: 'auto', 
                objectFit: 'contain',
              }} 
                />
        </div >
    );
};

export default SignIn2;
